import { render } from "./configuraciones.vue?vue&type=template&id=3b4d8d66"
import script from "./configuraciones.vue?vue&type=script&lang=js"
export * from "./configuraciones.vue?vue&type=script&lang=js"

import "./configuraciones.vue?vue&type=style&index=0&id=3b4d8d66&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__